import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { Rarity } from '__generated__/globalTypes';
import { colorPerRarity } from 'lib/colors';
import { scarcityMessages } from 'lib/scarcity';
import { Color } from 'style/types';

const Root = styled.span<{ color: Color }>`
  color: ${({ color }) => color};
  font-weight: var(--t-bold);
`;

type Props = { scarcity: Rarity };

export const ScarcityLabel = ({ scarcity }: Props) => {
  const { formatMessage } = useIntl();

  const label = formatMessage(scarcityMessages[scarcity]);

  return <Root color={colorPerRarity[scarcity]}>{label}</Root>;
};
